import { render, staticRenderFns } from "./PendingApprovalMortgageLoanModal.vue?vue&type=template&id=3799eab5"
import script from "./PendingApprovalMortgageLoanModal.vue?vue&type=script&lang=js"
export * from "./PendingApprovalMortgageLoanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports